import axios from "axios";
import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";
import { SelfDescribingEvent } from "../vendors/snowplow/context-api";

const GET_CONTEXTS_URL = "/tracking-contexts";

const getSPEvents = async <T>(contexts: T[]) =>
  await axios
    .post<SelfDescribingEvent[]>(GET_CONTEXTS_URL, {
      contexts,
    })
    .catch(() => {
      return {
        data: [],
      };
    });

const emitSnowplowEvent = (event: SelfDescribingEvent[]) => {
  event.forEach((snowplowEvent) => {
    trackSelfDescribingEvent({ event: snowplowEvent });
  });
};

/**
 * This function will make a call to the backend to retrieve the requested contexts.
 * Use trackSelfDescribingEvent instead if you have all the available data.
 */
export const submitSPEvents = async <T>(contexts: T[]) => {
  const response = await getSPEvents<T>(contexts);
  if (response?.data) {
    emitSnowplowEvent(response.data.flat().filter(Boolean));
  }
};
